module.exports = __webpack_public_path__ + "static/media/sg4tj0.3cb4de3e.png";